module.exports = __webpack_public_path__ + "img/lastenhuone_thumbnail_x2.21673afa.jpg";